// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"57185cb5","360":"7cfc7896","448":"a22240d8","810":"fcbd116e","922":"9b442304"}[chunkId] + ".chunk.css";
};